import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { StethoscopeIcon, CarIcon } from './icons/CustomIcons';
import { Calendar } from 'lucide-react';
export function HeroSection() {
  const scrollToContact = () => {
    document.getElementById('contacto')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-[90vh] flex items-center overflow-hidden bg-pure-black pt-20 pb-16 md:py-0" data-id="element-233">
      {/* Background Image for Mobile / Right Side for Desktop */}
      <div className="absolute inset-0 z-0 md:left-1/2 md:right-0" data-id="element-234">
        <div className="absolute inset-0 bg-gradient-to-b from-pure-black via-pure-black/80 to-pure-black md:bg-gradient-to-r md:from-pure-black md:via-pure-black/50 md:to-transparent z-10" data-id="element-235" />
        <img src="https://cdn.magicpatterns.com/uploads/srdGgXtXNUiLCS1yEYAGuV/heylloyd-image-1773462928664.png" alt="Professional Mechanic" className="w-full h-full object-cover object-center opacity-40 md:opacity-100" data-id="element-236" />
      </div>

      <div className="container mx-auto px-6 relative z-20" data-id="element-237">
        <div className="max-w-3xl md:w-1/2 md:pr-12" data-id="element-238">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-239">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-electric-yellow leading-tight mb-6" data-id="element-240">
              Que tu taller sea el Quirófano #1 de la ciudad.{' '}
              <br className="hidden md:block" data-id="element-241" />
              <span className="text-white flex items-center gap-3 flex-wrap mt-2" data-id="element-242">
                Sin bahías vacías.
                <span className="flex items-center gap-1 text-electric-yellow" data-id="element-243">
                  <StethoscopeIcon className="w-8 h-8 md:w-10 md:h-10" data-id="element-244" />
                  <CarIcon className="w-8 h-8 md:w-10 md:h-10" data-id="element-245" />
                </span>
              </span>
            </h1>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} data-id="element-246">
            <p className="text-lg md:text-xl text-gray-300 mb-10 leading-relaxed max-w-2xl" data-id="element-247">
              Atraemos clientes con problemas reales de motor y transmisión.
              Gente que necesita su auto para trabajar{' '}
              <strong className="text-white font-bold" data-id="element-248">HOY</strong>.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4,
          ease: 'easeOut'
        }} data-id="element-249">
            <div className="flex flex-col items-start gap-4" data-id="element-250">
              <Button onClick={scrollToContact} className="w-full md:w-auto" data-id="element-251">
                LLENAR MI TALLER AHORA
              </Button>
              <a href="https://calendar.app.google/gDsqAVqmwUYm" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-gray-400 hover:text-electric-yellow transition-colors text-sm font-medium" data-id="element-252">
                <Calendar className="w-4 h-4" data-id="element-253" />O agenda tu cita directamente
                aquí
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}